<template>
  <Button class="btn-outline-tertiary w-full" @click="redirect">
    Change the Application Signature Method
  </Button>
</template>

<script>
import Button from '@/components/Button/Button.vue';

export default {
  name: 'UpdateSignatureTypeRedirection',
  components: {
    Button,
  },
  props: {
    uuid: { required: false, type: String, default: () => '' },
  },
  methods: {
    redirect() {
      if (this.$store.state.eTransactionCreated && this.uuid) {
        this.$axios
          .post(`${process.env.VUE_APP_API_CONTEXT}/japi/IUzpApi/clearTransaction`, [this.uuid])
          .then(() => { this.$store.commit('SET_E_TRANSACTION_CREATED', false); });
      }

      this.$router.maxStep = 22;
      this.$router.push({ name: 'SignUpdate', query: this.$route.query });
    },
  },
};
</script>
